import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkCardAlohaPlaceholder } from 'uitk-react-cards';

import { Lazy, LazyProps } from './lazy';

interface SimpleLazyLoadWrapperProps extends LazyProps {
  currentHotel?: CurrentHotelStore;
  placeholder?: any;
  children: any;
}

/**
 * This component simplified lazy loading, but we shouldn't lazy load on dateless pages for SEO reasons.
 * So we check for that before lazy loading. - @jullberg
 */

export const SimpleLazyLoadWrapper: React.FunctionComponent<SimpleLazyLoadWrapperProps> = inject('currentHotel')(
  observer(({ children, currentHotel, placeholder = <UitkCardAlohaPlaceholder />, ...props }) => {
    if (currentHotel?.searchCriteria?.isDateless) {
      return <>{children}</>;
    }

    return (
      <Lazy {...props}>
        <Lazy.Placeholder>{placeholder}</Lazy.Placeholder>
        <Lazy.Loaded>{children}</Lazy.Loaded>
      </Lazy>
    );
  })
);
